import * as Sentry from '@sentry/react'

const SESSION_ID_KEY = '_ssid'

/**
 * Generate a random session ID for anonymous user correlation
 * Persists for browser session (cleared when tab closes)
 */
const getOrCreateSessionId = (): string => {
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY)
  if (!sessionId) {
    sessionId = crypto.randomUUID()
    sessionStorage.setItem(SESSION_ID_KEY, sessionId)
  }
  return sessionId
}

/**
 * Set anonymous session ID for Sentry correlation
 * Call this on app initialization
 */
export const initSentryAnonymousUser = (): void => {
  const sessionId = getOrCreateSessionId()
  Sentry.setUser({ id: `session:${sessionId}` })
}

/**
 * Set authenticated user for Sentry correlation
 * Call this after successful login
 */
export const setSentryAuthenticatedUser = (patientId: string): void => {
  Sentry.setUser({ id: `patient:${patientId}` })
}

/**
 * Clear user on logout, revert to session ID
 */
export const clearSentryUser = (): void => {
  initSentryAnonymousUser()
}
